<template>
    <div class="download-app-modal">
        <el-dialog
            title="" :width="isMobile?'85%':'460px'"
            :visible="showModal" :show-close="false" custom-class="download-modal-new"
            :before-close="handleClose">
            <div class="new-modal-content">
                <div class="close-btn" @click="handleClose">&times;</div>
                <div class="modal-header">
                    <h2 class="title">🎉{{currencySign}}{{currencySign=='￡'?'6':'10'}} OFF – In Partnership with ALL EAT!</h2>
                    <p class="subtitle">Download the ALL EAT App & use code 
                        "{{currencySign=='￡'?'ALLEAT':'ALLEATIE'}}"
                        to save {{currencySign}}{{currencySign=='￡'?'6':'10'}}!
                    </p>
                    <p class="deal">👉 App-only exclusive deals!</p>
                </div>
                <div class="modal-footer">
                     <div class="download-buttons">
                        <a class="download-now-btn" @click="downloadApp">Download Now</a>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "DownloadAppModal",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            seconds: {
                type: Number,
                default: 3000
            },
            currency: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                showModal : false
            }
        },
        computed: {
            isMobile() {
                return window.innerWidth < 950
            },
            currencySign() {
                return this.currency || (this.$isUk ? '￡' : '€');
            }
        },
        watch: {
            value(newVal) {
                this.showModal = newVal;
            }
        },
        mounted() {
            if(window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isSsg) {
                console.log('ssg渲染中')
            } else {
                setTimeout(() => {
                    // Don't show modal during server-side pre-rendering
                    console.log('window.__PRERENDER_INJECTED', window.__PRERENDER_INJECTED);
                    this.$emit('input', true);
                }, this.seconds);
            }
            
        },
        methods: {
            handleClose() {
                this.$emit('input', false);
                this.showModal = false;
            },
            downloadApp() {
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                // iOS detection 
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    window.open('http://itunes.apple.com/cn/app/id1603420846?mt=8', '_blank');
                } else {
                    // Otherwise, assume it's Android or others
                    window.open('https://play.google.com/store/apps/details?id=io.dcloud.uniAllEat', '_blank');
                }
            }
        }
    }
</script>

<style scoped lang="scss" >
.download-app-modal {
    :deep(.download-modal-new) {
        border-radius: 16px;
        overflow: hidden;
        padding: 0;
        background: #2ecc71;
        
        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            padding: 0;
        }
    }

    .new-modal-content {
        position: relative;
        text-align: center;
        color: white;
        word-break: break-word;
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 15px;
        font-size: 24px;
        color: white;
        cursor: pointer;
        font-weight: bold;
        z-index: 10;
    }

    .modal-header {
        background: #9b59b6; // purple
        padding: 30px 20px 50px 20px;
        clip-path: polygon(0 0, 100% 0, 100% calc(100% - 40px), 0 100%);
    }

    .title {
        font-size: 23px;
        font-weight: bold;
        margin: 0 0 20px 0;
        line-height: 1.3;
        word-break: break-word;
    }

    .subtitle {
        font-size: 16px;
        margin: 0 auto 15px auto;
        max-width: 380px;
        word-break: break-word;
    }

    .deal {
        font-size: 14px;
        margin: 0;
        word-break: break-word;
    }

    .modal-footer {
        padding: 30px 20px 20px 20px;
    }

    .download-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 15px;
    }

    .download-now-btn {
        background-color: white;
        color: #9b59b6;
        padding: 10px 35px;
        border-radius: 8px;
        font-weight: bold;
        text-decoration: none;
        cursor: pointer;
        font-size: 16px;
        transition: transform 0.2s;
    }

    .download-now-btn:hover {
        transform: scale(1.05);
    }

    .store-btn img {
        height: 45px;
        cursor: pointer;
    }
}

@media (max-width: 768px) {
    .title {
        font-size: 20px;
    }
    .subtitle {
        font-size: 14px;
    }
    .deal {
        font-size: 13px;
    }
    .download-buttons {
        flex-direction: column;
    }
}
</style>

